function initSizesFlickity() {
	const sizeSliders = document.querySelectorAll('.js-sizes-slider');
	sizeSliders.forEach((slider) => {
		if (!slider.flickity) {
			slider.flickity = new Flickity(slider, {
				prevNextButtons: true,
				pageDots: false,
				cellAlign: 'left',
				contain: true,
				groupCells: true,
			});
		}
	});
}

function destroySizesFlickity() {
	const sizeSliders = document.querySelectorAll('.js-sizes-slider');
	sizeSliders.forEach((slider) => {
		if (slider.flickity) {
			slider.flickity.destroy();
			slider.flickity = null;
		}
	});
}

function initializeSizesSliders() {
	if (isMobile()) {
		initSizesFlickity();
	} else {
		destroySizesFlickity();
	}
}

initializeSizesSliders();
window.addEventListener(
	'resize',
	debounce(() => {
		initializeSizesSliders();
	}, 100),
);
document.body.addEventListener('variant:change', initializeSizesSliders);
